import React, {useState, useEffect} from 'react'
import axios from 'axios'
import { IoUmbrellaOutline } from 'react-icons/io5'
import { MdWbSunny } from 'react-icons/md' 
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function  MlStock() {
  const [stockForecast1, setStockForecast1] = useState('')
  const [stockForecast2, setStockForecast2] = useState('')
  const [loadMl, setLoadMl]=useState(false)
  useEffect(() => {
    if(!loadMl){
      setTimeout(getMl, 2)
      setLoadMl(true)
    }
  })
  const getMl = async()=>{
    console.log('calling ml data..')
     const { data: res } = await axios.get(`${APIURL}/ml/stock`)
     console.log(res)
     setStockForecast1(res.data1)
     setStockForecast2(res.data2)
  }
  return(
    <>
      <p className='text-[8px]'>ML Model1: using past nasdaq_index_100 stock data from 20101201-20260131.<br/>500items 80%, 5000items 82% accuracy level.</p>
        {stockForecast1!=''?<><div className='flex w-fit border border-gray-800 text-[9px] font-bold'>
        <div className='w-[60px] mt-auto pl-[2px]'>Symbol</div>
        <div className='w-[80px] mt-auto'>Date</div>
        <div className='w-[60px] mt-auto'>Value</div>
        <div className='w-[80px]'></div>
        </div>
        {stockForecast1.map((x)=>
        <div className='flex w-fit border-b border-l border-r border-gray-800 text-[9px]'>
        <div className='w-[60px] pl-[2px]'>{x.stock}</div>
        <div className='w-[80px]'>{x.date}</div>
        <div className='w-[60px]'>{x.close}</div>
        <div className='w-[80px] flex'><div className='mt-auto mb-auto'>{x.mlforecast==0?<IoUmbrellaOutline/>:<MdWbSunny/>}</div><div className={`ml-[2px] mt-auto mb-auto font-bold leading-[1.2] text-[7px] ${Number(x.mlforcastaccuracylevel)>80?'text-green-600':'text-gray-400'}`}>{x.mlforcastaccuracylevel}% matched</div></div>
        </div>
       )}</>:<p className='flex text-xs'>Please wait for 5s<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>}
      <p className='text-[8px] mt-[4px]'>ML Model2: using past all company's stock in nasdaq from 20101201-20260131.<br/>5000items 79% accuracy level.</p>
      {stockForecast2!=''?<><div className='flex w-fit border border-gray-800 text-[9px] font-bold'>
        <div className='w-[60px] mt-auto pl-[2px]'>Symbol</div>
        <div className='w-[80px] mt-auto'>Date</div>
        <div className='w-[60px] mt-auto'>Value</div>
        <div className='w-[80px]'></div>
        </div>
        {stockForecast2.map((x)=>
        <div className='flex w-fit border-b border-l border-r border-gray-800 text-[9px]'>
        <div className='w-[60px] pl-[2px]'>{x.stock}</div>
        <div className='w-[80px]'>{x.date}</div>
        <div className='w-[60px]'>{x.close}</div>
        <div className='w-[80px] flex'><div className='mt-auto mb-auto'>{x.mlforecast==0?<IoUmbrellaOutline/>:<MdWbSunny/>}</div><div className={`ml-[2px] mt-auto mb-auto font-bold leading-[1.2] text-[7px] ${Number(x.mlforcastaccuracylevel)>80?'text-green-600':'text-gray-400'}`}>{x.mlforcastaccuracylevel}% matched</div></div>
        </div>
       )}</>:<p className='flex text-xs'>Please wait for 5s<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>}
    </>
  )
}